import React from "react";

export default function APIDataFetchLoader() {
  // useEffect(() => {
  //   const loader = document.getElementById("loader");

  //   // Show the loader when the page loads
  //   loader.style.display = "flex";

  //   // Simulate a delay to hide the loader (e.g., for API loading)
  //   setTimeout(() => {
  //     loader.style.display = "none";
  //   }, 500); // Adjust the time (2000ms = 2 seconds) as needed
  // }, []);
  return (
    <div id="loader">
      <div className="lds-hourglass"></div>
    </div>
  );
}
